import { createActionGroup } from '@ngrx/store';

export const ParagraphProgressActions = createActionGroup({
  source: 'ParagraphProgress',
  events: {},
});
